(() => {
  const form = document.querySelector('[data-gift-balance-form]');
  if (!form || form.dataset.ready) return;
  form.dataset.ready = 'true';
  form.addEventListener('submit', async event => {
    event.preventDefault();
    const button = form.querySelector('button');
    const output = form.querySelector('[data-gift-balance-result]');
    const input = form.querySelector('input');
    output.hidden = false; output.textContent = 'Checking your balance…';
    button.disabled = true;
    try {
      const response = await fetch('https://gift-card-balance.v2apps.com/balance', {
        method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({code:input.value}),credentials:'omit',cache:'no-store',signal:AbortSignal.timeout(20000)
      });
      const data = await response.json();
      if (!response.ok) { output.textContent = data.error || 'Please try again shortly.'; return; }
      const title = document.createElement('strong');
      title.textContent = 'Remaining balance: ' + new Intl.NumberFormat(document.documentElement.lang || 'en-US',{style:'currency',currency:data.currency}).format(Number(data.balance));
      const detail = document.createElement('span');
      const today = new Intl.DateTimeFormat('en-CA',{timeZone:'America/Chicago',year:'numeric',month:'2-digit',day:'2-digit'}).format(new Date());
      const expired = data.expiresOn && data.expiresOn < today;
      if (!data.enabled) detail.textContent = 'This code is inactive. Contact our team if you need help.';
      else if (expired) detail.textContent = 'This code has expired.';
      else if (Number(data.balance) <= 0) detail.textContent = 'This code has no remaining balance.';
      else detail.textContent = 'Enter this code at checkout to use your balance.';
      if (data.expiresOn) detail.textContent += ' Expiration date: ' + new Intl.DateTimeFormat('en-US',{year:'numeric',month:'long',day:'numeric',timeZone:'UTC'}).format(new Date(data.expiresOn+'T12:00:00Z')) + '.';
      output.replaceChildren(title,detail);
      input.value = '';
    } catch { output.textContent = 'We couldn’t check the balance right now. Please try again shortly or contact our team.'; }
    finally { button.disabled = false; }
  });
})();
